<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3 sidebar-org bg-custom-blue py-3">

        <!-- Header left sidebar -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">{{ $t("views.nav.manageOrgs") }}</h4>
          <button v-if="isAdmin" @click="openModal(false, '', 'orgUnit', 'add', '')" type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#orgUnitEditModal">+ {{ $t("general.add") }}</button>
          <button v-if="!isAdmin" type="button" class="btn btn-sm btn-primary" disabled> {{ $t("general.add") }} </button>
        </div>

        <!-- Time-Filter -->
        <div class="row mt-4">
          <div class="col-6">
            <div class="dropdown">
              <button class="btn btn-sm dropdown-toggle bg-white text-start" style="width: 200px" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span>{{ formatDate(new Date(filterValidFrom)) }} &nbsp;-&nbsp; {{ formatDate(new Date(filterValidTo)) }}</span>
              </button>
              <div class="dropdown-menu border-secondary p-3">
                <div class="row">
                  <div class="col-12">
                    <button @click="filterOrgUnits(new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10))" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ $t("general.today") }}</button>
                    <button @click="filterOrgUnits((new Date().getFullYear() + 1).toString() + '-01-01', (new Date().getFullYear() + 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() + 1 }}</button>
                    <button @click="filterOrgUnits(new Date().getFullYear().toString() + '-01-01', new Date().getFullYear().toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() }}</button>
                    <button @click="filterOrgUnits((new Date().getFullYear() - 1).toString() + '-01-01', (new Date().getFullYear() - 1).toString() + '-12-31')" class="btn btn-sm btn-outline-primary me-2 mb-2" type="button">{{ new Date().getFullYear() - 1 }}</button>
                  </div>
                </div>
                <hr class="dropdown-divider">
                <div class="row">
                  <div class="col-6">
                    <label for="filterValidFrom" class="form-label">{{ $t("views.kpi.periods.from") }}:</label>
                    <input v-model="filterValidFrom" type="date" class="form-control form-control-sm" id="filterValidFrom">
                  </div>
                  <div class="col-6">
                    <label for="filterValidTo" class="form-label">{{ $t("views.kpi.periods.to") }}:</label>
                    <input v-model="filterValidTo" type="date" class="form-control form-control-sm" id="filterValidTo">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <button @click="filterOrgUnits(filterValidFrom, filterValidTo)" class="btn btn-sm btn-outline-primary mt-3" type="button">{{ $t("views.kpi.periods.filter") }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search & Slider -->
        <div class="row mt-1">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Search -->
              <div class="me-3" style="width: 200px"> <input v-model="searchText" type="text" :placeholder="$t('general.placeholderSearch')" class="form-control form-control-sm mt-0" />
              </div>
              <!-- Level-Slider from 2 to maxTreeLevel -->
              <div class="d-flex flex-column align-items-start mb-2">
                <div class="fs-08 text-muted mb-1"> {{ $t('general.treeViewLevels') }}: {{ autoOpenDepth }} </div>
                <div class="d-flex align-items-center gap-2">
                  <input type="range" class="form-range foc-range" min="2" :max="maxTreeDepth" step="1" v-model="autoOpenDepth" :key="sliderKey">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <OrgUnitTree v-if="'nodes' in orgUnits && orgUnits.nodes.length" :node="orgUnits" :depth="0" mode="manage" :searchText="searchText" :autoOpenDepth="autoOpenDepth" class="mt-2"></OrgUnitTree>
          </div>
        </div>
      </div>

      <div class="col-9 px-5">
        <div v-if="Object.keys(selectedOrgUnit).length" class="row">
          <div class="col-12">
            <div class="row mt-3">
              <div class="col">
                <button v-if="selectedOrgUnit.write" @click="openModal(selectedOrgUnit.id, '', 'orgUnit', 'update', '')" type="button" class="btn btn-sm btn-outline-dark" data-bs-toggle="modal" data-bs-target="#orgUnitEditModal">&bull; {{ $t("general.update") }}</button>
              </div>
            </div>

            <!-- Name & Heading Data -->
            <div class="row mt-3">
              <div class="col">

                <div class="h4">{{ selectedOrgUnit.name }}</div>

                <ul class="list-group list-group-horizontal-md foc-list-header">
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.kpi.edit.responsible") }}:</div>
                    <div>{{ selectedOrgUnit.responsible.name }}</div>
                  </li>
                  <li class="list-group-item bg-white border-0">
                    <div class="foc-list-group-item-label">{{ $t("views.org.structure.validityPeriod") }}:</div>
                      <div>
                        <span v-if="selectedOrgUnit.validFrom"> {{ formatDate(new Date(selectedOrgUnit.validFrom)) }} - {{ formatDate(new Date(selectedOrgUnit.validTo)) }} </span>
                        <span v-else> {{ $t("views.org.structure.infinite") }} </span>
                      </div>
                  </li>
                </ul>

              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="card">
                  <div class="card-header fw-bold">{{ $t("views.org.detail.headingCard") }}</div>
                  <div class="card-body">
                    <ul class="nav nav-tabs border-bottom" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark active" id="definition-tab" data-bs-toggle="tab" data-bs-target="#definition" type="button" role="tab" aria-controls="definition" aria-selected="false">{{ $t("views.strategy.detail.tabDefinition") }}</button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark" id="employees-tab" data-bs-toggle="tab" data-bs-target="#employees" type="button" role="tab" aria-controls="employees" aria-selected="false">{{ $t("views.org.employee.employees") }} <span v-if="selectedOrgUnit.members.length" class="badge bg-primary">{{ selectedOrgUnit.members.length }}</span></button>
                      </li>
                    </ul>

                    <div class="tab-content mt-2">
                      <div class="tab-pane fade show active" id="definition" role="tabpanel">
                        <div v-if="selectedOrgUnit.description" class="mt-3">
                          <QuillContent :content="selectedOrgUnit.description" id="orgUnitDesc"></QuillContent>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.org.detail.noDescription") }}</div>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="employees" role="tabpanel">
                      <div v-if="selectedOrgUnit.write" class="row my-3">
                        <div class="col">
                          <button @click="openModal(false, '', 'member', 'add', '')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#orgUnitEditModal">+ {{ $t("general.add") }}</button>
                        </div>
                      </div>
                      <div v-if="selectedOrgUnit.members.length">
                        <table class="table">
                          <thead>
                            <tr class="border-dark">
                              <th scope="col">{{ $t("views.org.employee.name") }}</th>
                              <th scope="col">{{ $t("views.org.employee.email") }}</th>
                              <th scope="col">{{ $t("general.role") }}</th>
                              <th scope="col">{{ $t("general.headof") }}</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="member in selectedOrgUnit.members" :key="'person' + member.id">
                              <td>
                                <div class="cont-icon-org-unit d-inline-block me-1">
                                  <svg class="bi" width="16" height="16" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#employee-user" /> </svg> &nbsp;
                                  <a @click="selectEmployee(member.employeeId)" role="button" scope="row" class="fw-normal">{{member.firstName + ' ' + member.lastName}}</a>
                                </div>
                              </td>
                              <td>{{ member.email }}</td>
                              <td>{{ member.role }}</td>
                              <td class="ps-4">
                                <span v-if="member.leadIndicator">
                                  <svg class="bi" width="18" height="18" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#check"/> </svg>
                                </span>
                              </td>
                              <td v-if="selectedOrgUnit.write">
                                <div class="dropdown">
                                  <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                    <svg class="bi" width="28" height="28" fill="currentColor">
                                      <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                    </svg>
                                  </a>
                                  <ul class="dropdown-menu">
                                    <li><a @click="openModal(member.id, member.firstName + ' ' + member.lastName, 'member', 'update', member.role)" class="dropdown-item" href="#orgUnitEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                    <li><a @click="openModal(member.id, member.firstName + ' ' + member.lastName, 'member', 'remove', member.role)" class="dropdown-item" href="#orgUnitDeleteModal" data-bs-toggle="modal">{{ $t("general.remove") }}</a></li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-else class="mt-3 h6">{{ $t("views.org.detail.noEmployees") }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-5">
          <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
          <p v-if="'nodes' in orgUnits && orgUnits.nodes.length" class="h5 mt-3">{{ $t("views.org.structure.helpChooseOrgUnit") }}</p>
          <p v-if="isAdmin && this.$store.state.selectedView === 'org'" class="h5 mt-3"> {{ $t("views.org.structure.helpCreateOrgUnit") }}</p>
        </div>
      </div>
    </div>
    <OrgUnitEditModal></OrgUnitEditModal>
    <OrgUnitDeleteModal></OrgUnitDeleteModal>
  </div>
</template>

<script>
import OrgUnitTree from '@/components/org/OrgUnitTree.vue'
import OrgUnitEditModal from '@/components/org/OrgUnitEditModal.vue'
import OrgUnitDeleteModal from '@/components/org/OrgUnitDeleteModal.vue'
import QuillContent from '@/components/QuillContent.vue'
import * as formatUtils from '@/composables/formatUtils'
import * as tree from '@/composables/tree'

export default {
  name: 'OrgManageOrgUnit',
  data () {
    return {
      orgUnitModalElementId: false,
      orgUnitModalElementType: '',
      orgUnitModalMode: '',
      selectedElement: '',
      filterValidFrom: this.$store.state.user?.settings?.favorites?.orgUnitManage?.filterValidFrom ? this.$store.state.user.settings.favorites.orgUnitManage.filterValidFrom : new Date().getFullYear().toString() + '-01-01',
      filterValidTo: this.$store.state.user?.settings?.favorites?.orgUnitManage?.filterValidTo ? this.$store.state.user.settings.favorites.orgUnitManage.filterValidTo : (new Date().getFullYear() + 1).toString() + '-12-31',
      searchText: '',
      autoOpenDepth: 2,
      sliderKey: 0
    }
  },
  components: {
    OrgUnitTree,
    OrgUnitEditModal,
    OrgUnitDeleteModal,
    QuillContent
  },
  computed: {
    isAdmin () {
      return this.$store.state.user.role === 10387
    },
    sysParms () {
      return this.$store.state.sysParms
    },
    orgUnits () {
      return this.$store.state.orgUnits
    },
    selectedOrgUnit () {
      return this.$store.state.selectedOrgUnit
    },

    // maximale Strukturtiefe ermitteln (Fallback 2)
    maxTreeDepth () {
      return tree.getMaxTreeDepth(this.$store.state.orgUnits?.nodes, 2)
    }
  },

  watch: {
    'orgUnits.nodes': {
      handler (nodes) {
        if (!nodes || nodes.length === 0) return

        // Set Slider Default-Level (Fallback = 2)
        const depth = this.maxTreeDepth
        const defaultLevel = this.sysParms?.orgTreeDefaultLevel ?? 2
        this.autoOpenDepth = Math.min(Math.max(defaultLevel, 2), depth)

        // Render Slider
        this.sliderKey++
      },
      immediate: true
    }
  },

  methods: {
    async filterOrgUnits (filterFrom, filterTo) {
      this.$store.commit('SET_LOADING_STATUS', true)
      this.filterValidFrom = filterFrom
      this.filterValidTo = filterTo
      await this.$store.dispatch('getOrgUnits', { validFrom: filterFrom, validTo: filterTo, view: 'org' })
      await this.$store.dispatch('favoriteObject', { isList: false, objectKey: 'orgUnitManage', objectValue: { filterValidFrom: filterFrom, filterValidTo: filterTo } })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    openModal (id, name, elementType, mode, role) {
      if (id) {
        this.orgUnitModalElementId = id
      }
      this.selectedElement = name + ', ' + role
      this.orgUnitModalElementType = elementType
      this.orgUnitModalMode = mode
      this.role = role
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    },
    async selectEmployee (employeeId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getEmployee', employeeId).then(() => {
        this.$router.push({ name: 'OrgManageEmployee' })
      })
      this.$store.commit('SET_LOADING_STATUS', false)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)

    // check query params for selected OrgUnit
    let paramSelectedOrgUnit = ''
    if (this.$route.query.id) {
      paramSelectedOrgUnit = this.$route.query.id
    }

    // get filter values from param object
    if (paramSelectedOrgUnit !== '') {
      await this.$store.dispatch('getOrgUnit', paramSelectedOrgUnit)
      await this.$store.dispatch('getEmployees', { mode: 'default' })
      this.searchText = this.selectedOrgUnit.name
      this.filterValidFrom = this.selectedOrgUnit.validFrom || formatUtils.getTodayIso()
      this.filterValidTo = this.selectedOrgUnit.validTo || formatUtils.getTodayIso()
    }

    this.$store.commit('SET_SELECTED_VIEW', 'org')
    await this.$store.dispatch('getOrgUnits', { validFrom: this.filterValidFrom, validTo: this.filterValidTo, view: 'org' })

    if (Object.keys(this.selectedOrgUnit).length) {
      await this.$store.dispatch('getOrgUnit', this.selectedOrgUnit.id)
    }
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>
